import { __assign, __generator, __spreadArray } from "tslib";
import { call } from 'redux-saga/effects';
import { request } from '../../xhr/request';
function getFakeGroups(content_type, cursor) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line global-require
        var groups = require('@wix/da-sample-data').groups;
        var offset = Number(cursor !== null && cursor !== void 0 ? cursor : 0);
        var pinned = groups.slice(0, 2).map(function (group) { return (__assign(__assign({}, group), { isWatching: true, networkbar: {
                isPinned: true,
                hasNewContent: Math.random() > 0.8,
            } })); });
        var watched = groups.slice(2).map(function (group) { return (__assign(__assign({}, group), { isWatching: true, networkbar: {
                isPinned: false,
                hasNewContent: Math.random() > 0.8,
            } })); });
        var fetchWatched = content_type !== 'recommended_groups';
        var fetchRecommended = content_type !== 'watched_groups';
        var watchedGroups = fetchWatched
            ? {
                groups: __spreadArray(__spreadArray([], pinned, true), watched, true).slice(offset, offset + 5),
                hasMore: groups.length > offset + 5,
                cursor: offset + 5,
            }
            : undefined;
        var recommendedGroups = fetchRecommended
            ? {
                groups: groups
                    .slice(offset, 3)
                    .map(function (group, idx) { return (__assign(__assign({}, group), { userId: group.userId + 10000000 })); })
                    .map(function (group) { return (__assign(__assign({}, group), { isWatching: false })); }),
                hasMore: groups.length > offset + 3,
                cursor: offset + 3,
            }
            : undefined;
        return {
            mainNavNewItem: ['dyw'],
            watchedGroups: watchedGroups,
            recommendedGroups: recommendedGroups,
        };
    }
    return {};
}
export function fetchGroups(content_type, cursor) {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: '/networkbar',
                    params: { cursor: cursor, content_type: content_type, expand: 'user.networkbar,user.watch' },
                }, function () { return getFakeGroups(content_type, cursor); })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
export function doPinGroup(userid) {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: '/networkbar/pingroup',
                    data: { userid: userid },
                }, function () { return ({ success: true }); })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
export function doUnpinGroup(userid) {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: '/networkbar/unpingroup',
                    data: { userid: userid },
                }, function () { return ({ success: true }); })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
export function doUnrecommendGroup(userid) {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: '/networkbar/unrecommendgroup',
                    data: { userid: userid },
                }, function () { return ({ success: true }); })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
export function doToggleSection(section, isFoldedNow) {
    var data, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = {
                    content_type: section,
                    is_collapsed: isFoldedNow,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/networkbar/update_section',
                        data: data,
                    }, function () { return ({ success: true }); })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
//# sourceMappingURL=xhr.js.map